import React from 'react';
import Skeleton from 'react-loading-skeleton';

import '../mobile/VisaFxSimpleCalculatorMobile.scss';

interface VisaFxSimpleCalculatorMobileSkeletonProps {
    currencyOnRightSide?: boolean;
}

const VisaFxSimpleCalculatorMobileSkeleton = ({
    currencyOnRightSide = false,
}: VisaFxSimpleCalculatorMobileSkeletonProps) => (
    <article className="calculator-with-swap-button">
        <div className="from-to-currency-container">
            <div className={`from-currency ${currencyOnRightSide ? 'currency-on-right-side' : ''}`}>
                <div className="select-currency">
                    <Skeleton style={{ height: 40, width: 80 }} />
                </div>
                <div className="select-amount">
                    <Skeleton style={{ height: 40 }} />
                </div>
                <span className="spanner" />
            </div>
            <div className={`to-currency ${currencyOnRightSide ? 'currency-on-right-side' : ''}`}>
                <div className="select-currency">
                    <Skeleton style={{ height: 40, width: 80 }} />
                </div>
                <div className="select-amount">
                    <Skeleton style={{ height: 40 }} />
                </div>
            </div>
            <span className="spanner" />
        </div>
    </article>
);

export default VisaFxSimpleCalculatorMobileSkeleton;
